import React from "react";
import { StepProps } from "../../types";
import { useWebTranslation } from "translations";
import { useCurrentAnimal } from "components/Signup/store/selectors/animals";
import { previousInjuriesItems } from "components/Signup/components/PreviousInjuries/previousInjuries";
import { HealthHistoryEnum } from "components/Signup/store/state/types";
import ChatMessage, { ChatContainer } from "ui-kit/ChatMessage/ChatMessage";
import { Typography } from "ui-kit/Typography";
import Gutter from "ui-kit/Gutter";
import { PreviousInjuriesOverviewItem } from "components/Signup/components/PreviousInjuries/PreviousInjuriesOverviewItem";
import FlowButtons from "components/Signup/components/FlowButtons/FlowButtons";

const HealthOverview = ({
  previous,
  next,
  isValid,
  transitioning,
}: StepProps) => {
  const { t } = useWebTranslation();
  const { healthHistory, name } = useCurrentAnimal();

  const shouldShowRestrictionsDontApplyMessage = !(
    healthHistory.length === 1 &&
    previousInjuriesItems.find((item) => item.id === healthHistory[0])!.id ===
      HealthHistoryEnum.NO_ILLNESS
  );

  return (
    <ChatContainer leaving={transitioning}>
      <ChatMessage>
        <Typography>
          {t("signup.previous_injuries.we_want_to_understand", {
            name: name ?? "",
          })}
        </Typography>
      </ChatMessage>
      <Gutter size={1} />

      {healthHistory
        .filter((item) => item !== HealthHistoryEnum.NO_ILLNESS)
        .map((item) => (
          <ChatMessage key={item}>
            <PreviousInjuriesOverviewItem
              name={name ?? ""}
              key={item}
              id={item}
            />
          </ChatMessage>
        ))}

      <Gutter size={1} />
      {shouldShowRestrictionsDontApplyMessage && (
        <ChatMessage>
          <Typography>
            {t("signup.previous_injuries.restrictions_dont_apply")}
          </Typography>
        </ChatMessage>
      )}
      <FlowButtons
        inProgress={transitioning}
        backButton={false}
        next={next}
        disabled={!isValid}
        previous={previous}
        nextTitle={t("signup.previous_injuries.i_understand")}
      />
    </ChatContainer>
  );
};

export default HealthOverview;
